export default __webpack_public_path__ + "static/manling2-494d6e3a1056514cd8a8b1bb63f6d3d0.jpg";